import { ICTipoFeedItem } from '../enum';
import { ICUsuario } from './ic-usuario';

export class ICFeedItem {
    tipo: ICTipoFeedItem;
    usuario: ICUsuario;
    payload: string;
    dados: any;
    pendente: boolean;
    exibirNoFeed: boolean;
}